import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";

// let ghpages = require('gh-pages');
 
// ghpages.publish('dist', function(err) {

// });

ReactDOM.render(<App />, document.getElementById("root"));
